import { render } from "./SKUDataTableList.vue?vue&type=template&id=5ff3e79e&scoped=true"
import script from "./SKUDataTableList.vue?vue&type=script&lang=js"
export * from "./SKUDataTableList.vue?vue&type=script&lang=js"

import "./SKUDataTableList.vue?vue&type=style&index=0&id=5ff3e79e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff3e79e"]])

export default __exports__